import { render, staticRenderFns } from "./FeedbackButton.vue?vue&type=template&id=052f7859"
import script from "./FeedbackButton.vue?vue&type=script&lang=js"
export * from "./FeedbackButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports